import { ApiResult } from "./PromiseResult";

export interface transactions {
    patient_guid: string;
    status: string;
    t_type: number;
    payment_token: string;
    amount: number;
    currency_type: string;
}

export class FinalTransaction {
    patient_guid: string = '';
    payment_token: string = '';
    transaction_id: string = '';
    payment_method: string = '';
    deviceData: any = null;
    signature?: string = null;
}

export class InvoicePrint {
    api_result: ApiResult = new ApiResult(false);
    data: any = null;
    displayModal: boolean = false;
    showInvoice: string = 'showInvoice';
    printContent: string = 'print-content';

}
